import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {AudioQueueItem} from "./audioqueue.item";
import {AudioPlaybackService} from "./audioplayback.service";
import {RaEvent} from "../../event/RaEvent";
import {ComponentBase} from "../../base/ComponentBase";
import {AudioQueueEvent} from "../../event/AudioQueueEvent";
import {EventBus} from "../../event/EventBus";
import {AudioKeyParser} from "./audiokey.parser";
import {NetworkService} from "../interaction/network.service";
import {ModalConfig} from "../notification/modal.config";
import {BugsnagLoggingService} from "../logging/bugsnag-logging.service";
import {ClientConfiguration} from "../configuration/client.config";
import {filter} from "rxjs/operators";

@Injectable()
export class AudioQueueService extends ComponentBase {

    private queue: AudioQueueItem[] = [];

    constructor(private playbackService: AudioPlaybackService,
                private audioKeyParser: AudioKeyParser,
                private eventBus: EventBus,
                private networkService: NetworkService,
                private modalConfig: ModalConfig,
                private log: BugsnagLoggingService,
                private config: ClientConfiguration) {
        super("AudioQueueService");
        this.setupListeners();
    }

    public reset(): Observable<boolean> {
        this.queue = [];
        return this.playbackService.cancel();
    }

    public hardReset(): void {
        this.queue = [];
        this.playbackService.hardCancel();
        // this.unsetLock();
    }

    public isPlaying(): boolean {
        return this.playbackService.isAudioPlayerPlaying();
    }

    private start(): void {
        if (this.queue.length > 0) {
            if (!this.networkService.isOnline()) {
                this.modalConfig.openMessageModal("disconnect_network_error");
                this.hardReset();
                return;
            }
            this.playItem();
        }
    }

    private playItem(): void {
        let item: AudioQueueItem = this.queue.shift();
        let name: string = this.generateFileName(item);

        this.playbackService.playSequence(
            // ------audio file
            name,
            // ------success callback
            () => {
                console.log("name: " + name + "have successCallback: " + !!item.successCallback);
                if (item.successCallback) {
                    console.log("success callback in queue service: " + item.successCallback.toString());
                    item.successCallback();
                }
                this.onSuccess();
            },
            // ------error callback
            (errorString: string) => {
                if (item.errorCallback) {
                    item.errorCallback(errorString);
                }
                if (!this.config.superUser) {
                    this.onError(errorString);
                }
            },
            // ------play callback
            () => {
                if (item.playbackCallback) {
                    item.playbackCallback();
                }
            });
    }

    private onSuccess(): void {
        this.start();
    }

    private onError(errorString: string): void {
        this.log.log("opening error modal due to: " + errorString)
        this.hardReset();
        this.modalConfig.openMessageModal("disconnect_network_error");
    }

    private setupListeners(): void {
        let sub = this.eventBus.pipe(filter((e:RaEvent) => e.type === AudioQueueEvent.TYPE))
            .subscribe((e:AudioQueueEvent) => {
                if (!this.networkService.isOnline()) {
                    this.hardReset();
                    this.modalConfig.openMessageModal("disconnect_network_error");
                    return;
                }

                e.getPlayList().forEach(item => console.log(item.getAudioFile()));
                let audioQueueIdle = (this.queue.length === 0) && !this.playbackService.isAudioPlayerInitiated();
                this.addItems(e.getPlayList());
                this.log.log("idle:" + audioQueueIdle);
                if (e.shouldInterrupt() || audioQueueIdle) {
                    this.start();
                }
            });
        this.subscriptions.push(sub);
    }

    private addItems(playList: AudioQueueItem[]): void {
        this.queue = this.queue.concat(playList);
    }

    private generateFileName(item: AudioQueueItem): string {
        let name: string;
        if (item.shouldTranslate()) {
            name = this.audioKeyParser.parseAudioKeyUrl(item.getAudioFile());
        } else {
            name = item.getAudioFile();
        }

        return name;
    }
}
